// extracted by mini-css-extract-plugin
export default {"table_wrapper":"AbsensiDetail_table_wrapper__NVjCU"};